/** One thread with the Foundlio team, already answered. */

import type { MessageThread } from '../../services/messageService';
import { DEMO_WEBSITE_ID } from './site';
import { daysAgo } from './time';

export const demoMessageThread: MessageThread = {
  id: 'demo-thread-1',
  websiteId: DEMO_WEBSITE_ID,
  lastMessageAt: daysAgo(4),
  unreadCount: 0,
  messages: [
    {
      id: 'demo-message-1',
      sender: 'customer',
      body: 'Can we add the after-hours rate to the emergency page? People keep ringing to ask.',
      createdAt: daysAgo(5),
      readAt: daysAgo(5),
      deliveredAt: daysAgo(5),
      deliveryError: null,
    },
    {
      id: 'demo-message-2',
      sender: 'team',
      body: 'Added it under the call-out box and put the same line in the FAQ. Have a look and tell us if the wording is right.',
      createdAt: daysAgo(4),
      readAt: daysAgo(4),
      deliveredAt: daysAgo(4),
      deliveryError: null,
    },
  ],
};
